export const replyWithAttachmentLastModifiedText = "hNb";
export const accessedOnText = "iNb";
export const replyWithMenuHeaderText = "jNb";
export const suggestedFilesText = "kNb";
export const suggestedAttachmentsReceivedFromText = "lNb";
export const suggestedAttachmentsReceivedFromAgoText = "mNb";
export const suggestedAttachmentsReceivedAgoText = "nNb";
export const suggestedAttachmentsOnText = "oNb";
export const suggestedAttachmentsOnOnedriveText = "pNb";
export const suggestedAttachmentsModifiedByText = "qNb";
export const suggestedAttachmentsCreatedByOwnerText = "rNb";
export const suggestedAttachmentsSentText = "sNb";
export default {replyWithAttachmentLastModifiedText,accessedOnText,replyWithMenuHeaderText,suggestedFilesText,suggestedAttachmentsReceivedFromText,suggestedAttachmentsReceivedFromAgoText,suggestedAttachmentsReceivedAgoText,suggestedAttachmentsOnText,suggestedAttachmentsOnOnedriveText,suggestedAttachmentsModifiedByText,suggestedAttachmentsCreatedByOwnerText,suggestedAttachmentsSentText};